import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const PDF_MARGIN_MM = 8;
const PDF_PAGE_WIDTH_MM = 210;
const PDF_PAGE_HEIGHT_MM = 297;

export function summaryPdfFilename(appName) {
  const base = String(appName || "intake-summary")
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
  return `${base || "intake-summary"}.pdf`;
}

/**
 * Capture a DOM node as a multi-page A4 PDF (visual match to on-screen summary).
 */
export async function exportElementToPdf(element, filename = "summary.pdf", options = {}) {
  if (!element) throw new Error("No element to export");

  const { captureWidth = 1200, scale = 2 } = options;
  const previousWidth = element.style.width;
  const previousMinWidth = element.style.minWidth;
  const previousMaxWidth = element.style.maxWidth;

  element.style.width = `${captureWidth}px`;
  element.style.minWidth = `${captureWidth}px`;
  element.style.maxWidth = `${captureWidth}px`;

  try {
    const canvas = await html2canvas(element, {
      scale,
      useCORS: true,
      allowTaint: true,
      logging: false,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: captureWidth,
      onclone: (clonedDoc) => {
        clonedDoc.querySelectorAll("[data-export-hide]").forEach((el) => {
          el.style.display = "none";
        });
      },
    });

    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const printableWidth = PDF_PAGE_WIDTH_MM - PDF_MARGIN_MM * 2;
    const printableHeight = PDF_PAGE_HEIGHT_MM - PDF_MARGIN_MM * 2;
    const imgWidth = printableWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const imgData = canvas.toDataURL("image/png");

    let offsetY = 0;
    let pageIndex = 0;

    while (offsetY < imgHeight) {
      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(
        imgData,
        "PNG",
        PDF_MARGIN_MM,
        PDF_MARGIN_MM - offsetY,
        imgWidth,
        imgHeight
      );
      offsetY += printableHeight;
      pageIndex += 1;
    }

    pdf.save(filename);
  } finally {
    element.style.width = previousWidth;
    element.style.minWidth = previousMinWidth;
    element.style.maxWidth = previousMaxWidth;
  }
}
